<template>
  <div v-if="bootstrapStore.isInit" class="bg-slate-100">
    <div
      class="relative border-slate-300 border mx-auto max-w-md flex flex-col   items-stretch border-b border-sand"
      ref="pageElement">
      <template v-if="!isHomeRoute && uiMounted ">
        <div class="flex items-center justify-between border-b border-gray-300 shadow border-marble h-16 bg-white">
          <div class="flex flex-row items-center mx-4" >
            <div @click="toHome" class="flex items-center space-x-2 cursor-pointer border border-gray-300 rounded-lg px-2 py-2">
              <i class="fa-solid fa-arrow-left text-xl text-gray-900 mx-2"></i>
            </div>

            <span class="text-lg ml-4 text-gray-900 font-bold">{{ appStateStore?.pageTitle }}
            </span>
          </div>

          <div class="flex items-center mx-2 gap-x-2 relative flex-shrink-0">
            <button v-if="isShowDropdownButton" class="mr-4" @click="isOpenDropdown = !isOpenDropdown">
              <span class="text-xl"><i class="fa-solid fa-ellipsis-vertical"></i></span>
            </button>

            <transition name="fade">
              <div v-if="isOpenDropdown"
                class="origin-top-right absolute right-0 top-5 z-30 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                <div class="py-1">
                  <button @click="openProduceBookDesktop"
                    class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 space-x-2">
                    <span>Share to Desktop</span>
                    <span><i class="fa-solid fa-share-from-square"></i></span>
                  </button>
                </div>
              </div>
            </transition>

            <button @click="handleUpgrade" v-if="eventStore.getPackage == 'free'"
              class="px-4 py-2 bg-blue-700 rounded-lg shadow-xl text-white">
              UPGRADE
            </button>
          </div>

          
        </div>

        <div v-if="eventStore.getPackage == 'free'" class="text-center bg-yellow-100">
          <div class="text-xs text-red-500 py-2 cursor-pointer" >
            <p>คุณกำลังทดลองใช้งาน (รองรับเขียนคำอวยพร 10 รูป)</p>
            <p class="" v-if="isRealtimeSlideRoute">และรองรับการอัพโหลดสูงสุด 10 รูป</p>
          </div>
          <div class="bg-white border-sand border-b border-solid"></div>
        </div>

        <div v-if="!eventStore.isOwner && authStore.user?.eventId" class="text-center bg-yellow-100">
          <div class="text-xs text-gray-700 py-2">Viewer Mode</div>
          <div class="bg-white border-sand border-b border-solid"></div>
        </div>
      </template>
      <div class="min-h-screen pb-16">
        <slot />
      </div>
    </div>
  </div>

  <div v-else-if="bootstrapStore.failed">
    <div class="flex items-center justify-center h-screen">
      <!-- <div class="text-2xl">Please access from LINE Offcial Account</div> -->
      <div class="text-2xl">Redirect To Line Login...</div>
    </div>
  </div>

  <div v-else>
    <div class="flex flex-col h-screen justify-between">
      <div class="flex items-center justify-center flex-grow">
        <div class="text-2xl">Loading...</div>
      </div>
      <div class="flex justify-center pb-4">
        <span class="text-gray-500 text-sm">version {{ version }}</span>
      </div>
    </div>
  </div>
  <GlobalLoading />
  <GlobalToast />
  <GlobalDevEventOverride v-if="isAdminTeam"/>
</template>

<script setup>
import _ from "lodash";
import packageJson from "~/package.json";
import { onClickOutside } from '@vueuse/core'
import { useUserStore } from "~/stores/user";

 
const bootstrapStore = useBootstrapStore();
bootstrapStore.init();

const appStateStore = useAppStateStore();

// //CHECK DEV MODE
const eventStore = useEventStore();
const authStore = useAuthStore();
const userStore = useUserStore()
const router = useRouter();
const route = useRoute();
const editDataStore = useEditDataStore();
const uiMounted = ref(false)
onMounted(() => {
  uiMounted.value = true
})
const version = ref(packageJson.version);
const isAdminTeam = computed(() => userStore.user?.admin === true || false)
const currentPath = computed(() => route?.path)
const isRealtimeSlideRoute = computed(() => {

  const isRealtimePage = _.includes(['/v3/realtime-slides', '/v3/realtime-slides/gallery'], currentPath.value)
  return isRealtimePage
})
const isHomeRoute = computed(() => {
  if(route?.path === "/v3/home" || route?.path === "/v3" || route?.path === "/") {
    return true
  }
  
  return false
});
const isShowDropdownButton = computed(() => {
  if (currentPath.value === '/v3/edit-data-custom' && editDataStore?.customEditDataType === 'producebook') {
    return true
  }
  return false
})
const isOpenDropdown = ref(false)
const pageElement = ref('')
onClickOutside(pageElement, () => {
  isOpenDropdown.value = false
})


watch(() => currentPath.value, () => {
  isOpenDropdown.value = false
})

const toHome = () => {
  if (isHomeRoute?.value) {
    return
  }

  const routeList = ['v3-wish', 'v3-realtime-slides', 'v3-promptpay', 'v3-produce-book', 'v3-wish-list', 'v3-profile','v3-produce-book-form-submitted' ]
  const isMatch = _.filter(routeList, r => r == route?.name)[0]
  if(isMatch) {
    return router.push('/v3/home')
  }

  router.back();
};

const handleUpgrade = () => {
  navigateTo("/package/price");
};

const openProduceBookDesktop = () => {
  isOpenDropdown.value = false  
  router.push('/v3/desktop/?page=producebook')
}

</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
